import type { FunctionalComponent as FC } from 'vue'
import type { MenuClickEventHandler } from 'ant-design-vue/es/menu/src/interface'
import Resource from '~/components/resource'
const Ellipsis = getFeUrl('/youyan-platform/png/ellipsis.png')

type IProps = {
  data: any
  menus: any[]
  keyItem?: any
  updateData?: (key: string, value: any) => void
}

export const CardMenu: FC<IProps> = (props) => {
  const click: MenuClickEventHandler = ({ item }) => {
    item?.click?.(props.data, props.updateData, props.keyItem)
  }
  return (
    <a-dropdown placement="bottomRight" destroyPopupOnHide>
      {{
        default: () => (
          <span
            class="brand-card-menu tools hover hover:bg-back-5"
            onClick={(ev) => ev.stopPropagation()}
          >
            <Resource src={Ellipsis} transformResource={transformImage} />
          </span>
        ),
        overlay: () => <a-menu items={props.menus} onClick={click} />,
      }}
    </a-dropdown>
  )
}
